import type { TFunction } from "@/modules/i18n/components/types"

type ContractDescriptionOptions = {
  contract: string
  contractDurationMin: number | null
  contractDurationMax: number | null
}

// FIXME : see to refacto this code in a more readable way
export const getContractDescription = (
  options: ContractDescriptionOptions,
  t: TFunction<"shared_contract_type" | "shared_months" | "job_offers">
): string | undefined => {
  const { contract, contractDurationMin, contractDurationMax } = options
  const result = ["", "", ""] // Assuming we get only 3 parts : contract, start and duration

  if (contract && contract.length > 0) {
    result[0] = t(`shared_contract_type.${contract}`)
  }

  if (
    contractDurationMax &&
    contractDurationMax > 0 &&
    contractDurationMin &&
    contractDurationMin > 0 &&
    result[0].length > 0
  ) {
    if (contractDurationMin === contractDurationMax) {
      result[1] = t(`shared_months.label`, {
        count: contractDurationMin,
      })
    } else {
      result[1] = t("job_offers.offer.duration", {
        max: contractDurationMax,
        min: contractDurationMin,
      })
    }
  }

  return result.filter(item => item.length > 0).join(" ")
}
